import React from 'react';
import { modules } from '../data/offer';
export function Modules() {
  return <section className="w-full bg-ink" data-id="element-83" data-mp="1r6c3yv9clfvc">
      <div className="mx-auto max-w-6xl px-5 py-20 sm:px-8 lg:py-28" data-id="element-84" data-mp="1r5ajk06fzh0y">
        <div className="max-w-3xl" data-id="element-85" data-mp="1vxbyjtuzvluo">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.22em] text-volt" data-id="element-86" data-mp="1vydcq77b4ogm">
            What’s inside
          </p>
          <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tightest text-white sm:text-6xl" data-id="element-87" data-mp="20xzpkfj842ow">
            The most complete resource for HYROX professionals
          </h2>
          <p className="mt-6 font-sans text-lg leading-relaxed text-muted" data-id="element-88" data-mp="1d6knmnvczne6">
            This isn’t a PDF of workouts. It’s a professional system — six
            modules that take you from physiology to positioning.
          </p>
        </div>

        <ol className="mt-14 border-t border-line" data-id="element-89" data-mp="2oky61d7cfamt">
          {modules.map(module => <li key={module.number} className="grid grid-cols-[auto_1fr] items-baseline gap-x-6 border-b border-line py-8 sm:grid-cols-[6rem_18rem_1fr] sm:gap-x-10" data-id="element-90" data-mp="2tk1bgyr8jivb">
              <span className="font-display text-4xl font-extrabold leading-none tracking-tightest text-volt sm:text-5xl" data-id="element-91" data-mp="1sqfd7buplqn">
                {module.number}
              </span>
              <h3 className="font-display text-2xl font-bold uppercase leading-tight tracking-tightest text-white sm:text-3xl" data-id="element-92" data-mp="3oxxzedn2ukf6">
                {module.title}
              </h3>
              <p className="col-span-2 mt-3 font-sans text-base leading-relaxed text-muted sm:col-span-1 sm:mt-0" data-id="element-93" data-mp="3f2eeema1x657">
                {module.description}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}